import React from "react";

import { Loader } from "@culturehq/components";
import { Preview } from "@creatomate/preview";

interface StaticPlayerProps {
  isLoading: boolean;
  onSetupPlayer: (element: HTMLDivElement) => void;
  previewRef: React.MutableRefObject<Preview | undefined>;
}

const StaticPlayer: React.FC<StaticPlayerProps> = ({
  isLoading, onSetupPlayer, previewRef
}) => (
  <>
    {isLoading && (
      <div className="LoaderContainer">
        <Loader loading />
      </div>
    )}
    <div
      className="Media-Iframe"
      ref={element => {
        if (element && element !== previewRef.current?.element) {
          onSetupPlayer(element);
        }
      }}
    />
  </>
);

export default StaticPlayer;
